import React, { Component } from "react";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";
import AreYouSureDialog from "../dialog/AreYouSureDialog";
import moment from "moment";

const styles = (theme) => ({
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  secondarySpan: {
    verticalAlign: "middle",
    marginLeft: "5px",
  },
});
export class ItemExpertQuestionTemplate extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    extendedString: "",
    deleteConfirmOpen: false,
  };
  componentDidMount() {
    this.extendedInfo(this.props.extendedSettings);
    this.secondaryInfo(this.props.listSettings);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }
  render() {
    return (
      <>
        <KpsListItem
          preText={this.props.preText}
          isPortlet={false}
          onItemClick={
            !this.props.edit &&
            (() => this.props.selectTemplate(this.props.data))
          }
          extendedString={this.state.extendedString}
          secondaryAction={
            <>
              {this.props.expert && (
                <Tooltip title={this.props.t("global_edit")}>
                  <IconButton>
                    <EditIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.openEdit(this.props.data);
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {this.props.expert && (
                <Tooltip title={this.props.t("global_delete")}>
                  <IconButton>
                    <CloseIcon onClick={this.onDelete} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          }
        >
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={this.primaryInfo()}
            secondary={this.primaryInfo()}
          />
        </KpsListItem>
        {this.state.deleteConfirmOpen && (
          <AreYouSureDialog
            open={this.state.deleteConfirmOpen}
            onClose={() => {
              this.setState({ deleteConfirmOpen: false });
            }}
            onSubmit={this.deleteTemplate}
          >
            <Trans i18nKey="confirm_delete_portlet_list" />
          </AreYouSureDialog>
        )}
      </>
    );
  }
  deleteTemplate = () => {};
  onDelete = (e) => {
    e.stopPropagation();
    this.setState({ deleteConfirmOpen: true });
  };
  primaryInfo() {
    let info = this.props.data.name;
    return info;
  }
  secondaryInfo = (settings) => {
    if (this.props.fullscreen) {
      if (!this.props.fullscreenSettings) {
        settings = [];
        for (
          let i = 0;
          i < this.props.expertQuestionTemplateSettingsOptions.length;
          i++
        ) {
          settings.push({
            label: this.props.expertQuestionTemplateSettingsOptions[i],
            order: i,
          });
        }
      } else {
        settings = JSON.parse(settings);
      }
    } else {
      if (!settings) {
        settings = "settings_document_author";
      }
    }
    const { classes } = this.props;
    let info = (
      <div>
        {this.props.fullscreen
          ? settings.map((setting) => {
              return this.returnSettingItem(setting);
            })
          : this.returnSettingItem(settings)}
      </div>
    );
    this.setState({ secondaryString: info });
  };
  returnSettingItem = (settings) => {
    let fontWeight = { fontWeight: this.props.fullscreen ? "bold" : "normal" };
    const { classes } = this.props;
    return (
      <span className={classes.iconSpan}>
        {settings === "settings_expert_question_template_description" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_expert_question_template_description")}
            </div>
            <div>: {this.props.data.description}&nbsp;</div>
          </div>
        )}
        {settings === "settings_expert_question_template_created_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_expert_question_template_created_date")}
            </div>
            <div>
              :{" "}
              {moment(this.props.data.createdDate).format(
                "DD/MM/YYYY HH:mm:ss"
              )}&nbsp;
            </div>
          </div>
        )}
        {settings === "settings_expert_question_template_creator_username" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t(
                "settings_expert_question_template_creator_username"
              )}
            </div>
            <div>: {this.props.data.creatorUsername}&nbsp;</div>
          </div>
        )}
      </span>
    );
  };
  extendedInfo(settings) {
    const { classes } = this.props;
    if (!settings) {
      settings = [];
      for (
        let i = 0;
        i < this.props.expertQuestionTemplateOptions.length;
        i++
      ) {
        settings.push({
          label: this.props.expertQuestionTemplateOptions[i],
          order: i,
        });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <TableRow key={idx}>
              <TableCell>{this.props.t(setting.label)}</TableCell>
              {setting.label ===
                "settings_expert_question_template_description" && (
                <TableCell>{this.props.data.description}</TableCell>
              )}
              {setting.label ===
                "settings_expert_question_template_created_date" && (
                <TableCell>
                  {moment(this.props.data.createdDate).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )}
                </TableCell>
              )}
              {setting.label ===
                "settings_expert_question_template_creator_username" && (
                <TableCell>{this.props.data.creatorUsername}</TableCell>
              )}
            </TableRow>
          );
        })}
      </>
    );
    this.setState({ extendedString });
  }
}
const mapStateToProps = (state) => ({
  expertQuestionTemplateOptions:
    state.selectionOption.expertQuestionTemplateSettingsOptions,
});
export default connect(
  mapStateToProps,
  null
)(
  withTranslation()(withStyles(styles)(withRouter(ItemExpertQuestionTemplate)))
);
